var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61403 9.31609C4.44272 9.72534 3.86288 9.72534 3.69158 9.31609L0.413403 1.48441C0.275505 1.15496 0.51749 0.791348 0.874628 0.791348L7.43097 0.791348C7.78811 0.791348 8.0301 1.15496 7.8922 1.48441L4.61403 9.31609Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedropdown);
export default __webpack_public_path__ + "static/media/closedropdown.130e60cd33d5098f1e2eb2fe9726df5b.svg";
export { ForwardRef as ReactComponent };